import { ApiResponse } from '@interfaces/api-response/1.0';
import { Association } from '@interfaces/association/1.0';
import { CatalogItem } from '@interfaces/catalog/1.0/catalog-item';
import { ErrorResponse } from '@interfaces/error/1.0';
import { ProductGroup } from '@interfaces/product-group/1.0';
import { Product } from '@interfaces/product/1.0';
import { MenuAvailability } from '@generated/tcea/models/menu-availability';
import { Variants } from '@generated/tcea/models/variants';
import { DisplayPricing } from '@generated/tcea/models/display-pricing';

export interface Composite extends CatalogItem {
  productGroupIds?: string[];
  compositeType: CompositeType;
  images?: { [id: string]: string };
  productGroupContextData?: ProductGroupOverride[];
  calories?: string;
  sodium?: SodiumContent;
  caloricCount?: CaloricCount;
  caloricCountInput?: CaloricCountInput;
  availability?: MenuAvailability;
  variants?: Variants;
  componentType?: string;
  displayPricing?: DisplayPricing | null;
  pluLookup?: string | null;
  displayType?: string | string[];
  componentGroupContextData?: ComponentGroupOverride[];
  componentGroups?: {
    componentGroupIds: string[];
    componentGroupOverrides: {
      [id: string]: ComponentGroupOverride;
    };
  };
  nutritionInfo?: {};
  defaultSelection?: {
    catalogEntryId: string;
    dataGroupId: string;
  };
  skuNumber?: string;
  sku?: string;
  promotion?: {
    promotion: boolean;
    promotionIds?: {
      brink?: string;
      xenial?: string;
      'xenial-corp'?: string;
    };
  };
}

export interface CompositeResponse extends ApiResponse {
  _embedded: {
    composites: Composite[];
  };
}

export enum CompositeType {
  COMBO = 'COMBO',
  BUNDLE = 'BUNDLE',
  CONTAINER = 'CONTAINER',
  PIZZA_COMPONENT = 'PIZZA_COMPONENT',
  PIZZA_CONTAINER = 'PIZZA_CONTAINER',
  HALF_PIZZA_CONTAINER = 'HALF_PIZZA_CONTAINER',
}

export interface ProductGroupOverride {
  productGroupId: string;
  defaultProductIds: string[];
  minimumRequired: number;
  maximumAllowed: number;
  rollUpContainerPrice?: boolean;
}

export interface CompositeOverrideInput {
  payload: ProductGroupOverride[];
}

export interface HeroComboRequest {
  title: string;
  description: string;
  name: string;
  rawPosValue: string;
  heroProductId?: string;
}

export interface HeroComboResponse {
  heroProductCatalogEntry: Product;
  heroProductGroupCatalogEntry: ProductGroup;
  heroCompositeCatalogEntry: Composite;
  association: Association;
}

export interface HeroComboErrorResponse {
  errorResponse: ErrorResponse;
  partialResponse: HeroComboResponse;
}

export interface SodiumContent {
  unit: string;
  value: string;
}

export interface CaloricCount {
  higherRangeInCal: number;
  higherRangeInKcal: number;
  higherRangeInkJ: number;
  lowerRangeInCal: number;
  lowerRangeInKcal: number;
  lowerRangeInkJ: number;
  servings: number;
}

export interface CaloricCountInput {
  caloricUnit: 'kJ' | 'kcal';
  lowerRange: number;
  higherRange: number;
  servings: number;
}

export interface ComponentGroupOverride {
  componentGroupId: string;
  defaultComponentIds: string[];
  minimumQuantity: number;
  maximumQuantity: number;
  instructionIds: string[];
}
